<template>
    <v-col
        :cols="width"
    >
        <v-radio-group
            :disabled="readonly"
            :label="item.props.label"
            :row="item.props.row"
            :rules="rules"
            ref="input"
            v-bind:name="item.name"
            v-model="modelData"
            dense
        >
            <span v-if="item.props.radioIsInline && item.props.required" class="required"></span>

            <v-radio
                v-for="(thisItem, index) in item.props.items"
                v-bind:key="item.name + index"
                v-bind:label="thisItem.text"
                v-bind:value="thisItem.value"
                color="primary"
            />
            
            <template v-if="item.props.tooltip" v-slot:append>
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>
        </v-radio-group>
    </v-col>
</template>
<script>
    export default {
        name: 'RadioList',
        // props: ['item', 'value', 'readonly', 'rules', 'width'],
        props: {
            item: Object,
            value: [String, Number],
            readonly: Boolean,
            rules: Array,
            width: [String, Number],
            handleTabChange: Function,
            openQuestionnaire: Function
        },
        computed: {
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                }
            }
        },
        methods: {
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    span.required::after {
        content: "*";
        color: #ff0000;
        margin-left: -0.3em;
        margin-right: 0.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/radio-list.vue